import { useSuitVersion } from '../hooks/useSuit';
import { SuitViewer } from './SuitViewer';

export function SuitContainer(props: { metadataId: string; batch: string }) {
  const suit = useSuitVersion(props.batch, props.metadataId);
  return <SuitViewer suit={suit} />;
}
